import celiosLogo from "@/public/images/clients/celios.png";
import arabNewsLogo from "@/public/images/clients/arabnews.png";
import barisanCoLogo from "@/public/images/clients/barisanco.png";
import bisnisComLogo from "@/public/images/clients/bisniscom.png";
import detikEduLogo from "@/public/images/clients/detikedu.png";
import heraldIdLogo from "@/public/images/clients/heraldid.png";
import idnTimesLogo from "@/public/images/clients/idntimes.png";
import indoposCoIdLogo from "@/public/images/clients/indoposcoid.png";
import kabariLogo from "@/public/images/clients/kabari.png";
import kompasComLogo from "@/public/images/clients/kompascom.png";
import kuatBacaComLogo from "@/public/images/clients/kuatbacacom.png";
import medcomIdLogo from "@/public/images/clients/medcomid.png";
import mongabayLogo from "@/public/images/clients/mongabay.png";
import rmIdLogo from "@/public/images/clients/rmid.png";
import rmolIdLogo from "@/public/images/clients/rmolid.png";
import satuJuangComLogo from "@/public/images/clients/satujuangcom.png";
import siapgrakComLogo from "@/public/images/clients/siapgrakcom.png";
import soloposJatengLogo from "@/public/images/clients/soloposjateng.png";
import suaraComLogo from "@/public/images/clients/suaracom.png";
import validNewsLogo from "@/public/images/clients/validnews.png";
import wartaekonomiLogo from "@/public/images/clients/wartaekonomi.png";

import Image from "next/image";
import React from "react";

const clients = [
  {
    name: "Celios",
    logo: celiosLogo,
    h: 20,
    w: 64,
  },
  {
    name: "Arab News",
    logo: arabNewsLogo,
    h: 20,
    w: 128,
  },
  {
    name: "Barisan Co",
    logo: barisanCoLogo,
    h: 20,
    w: 128,
  },
  {
    name: "Bisnis.com",
    logo: bisnisComLogo,
    h: 20,
    w: 64,
  },
  {
    name: "Detik Edu",
    logo: detikEduLogo,
    h: 20,
    w: 128,
  },
  {
    name: "Herald ID",
    logo: heraldIdLogo,
    h: 20,
    w: 128,
  },
  {
    name: "IDN Times",
    logo: idnTimesLogo,
    h: 20,
    w: 128,
  },
  {
    name: "Indopos.co.id",
    logo: indoposCoIdLogo,
    h: 20,
    w: 128,
  },
  {
    name: "Kabari",
    logo: kabariLogo,
    h: 20,
    w: 128,
  },
  {
    name: "Kompas.com",
    logo: kompasComLogo,
    h: 20,
    w: 128,
  },
  {
    name: "Kuatbaca.com",
    logo: kuatBacaComLogo,
    h: 20,
    w: 128,
  },
  {
    name: "Medcom.id",
    logo: medcomIdLogo,
    h: 20,
    w: 128,
  },
  {
    name: "Mongabay",
    logo: mongabayLogo,
    h: 20,
    w: 128,
  },
  {
    name: "RM.id",
    logo: rmIdLogo,
    h: 20,
    w: 128,
  },
  {
    name: "Rmol.id",
    logo: rmolIdLogo,
    h: 20,
    w: 128,
  },
  {
    name: "Satujuang.com",
    logo: satuJuangComLogo,
    h: 20,
    w: 128,
  },
  {
    name: "Siapgrak.com",
    logo: siapgrakComLogo,
    h: 20,
    w: 128,
  },
  {
    name: "Solopos Jateng",
    logo: soloposJatengLogo,
    h: 20,
    w: 128,
  },
  {
    name: "Suara.com",
    logo: suaraComLogo,
    h: 20,
    w: 128,
  },

  {
    name: "Validnews",
    logo: validNewsLogo,
    h: 20,
    w: 128,
  },
  {
    name: "Wartaekonomi",
    logo: wartaekonomiLogo,
    h: 20,
    w: 128,
  },
];

const Clients: React.FC = () => {
  return (
    <div className="w-full mx-auto max-w-5xl px-5 lg:p-0">
      <ul className="flex flex-wrap gap-5 items-center justify-between">
        {clients.map((client) => (
          <li key={client.name} className="flex h-14 items-center justify-center">
            <Image
              src={client.logo}
              alt={client.name}
              height={client.h}
              width={client.w}
              className="h-10 w-auto max-w-32 object-contain grayscale hover:grayscale-0"
            />
          </li>
        ))}
      </ul>
    </div>
  );
}

Clients.displayName = "Clients";
export default Clients;
